import '@css/modules-pages/landing.css';
import axios from 'axios';
import limitCheckbox from '@utils/limitCheckbox';

const scroolToOptions = { behavior: 'smooth', block: 'nearest' };

/**
 * toggle required on inputs elements
 * @param {Element[]} elements
 */
function toggleRequired(elements) {
  elements.forEach((el) => {
    el.required = !el.required;

    if (
      el.tagName === 'SELECT' &&
      el.labels.length > 0 &&
      !el.labels?.[0].innerText.includes('*')
    ) {
      el.labels[0].innerText = el.labels[0].innerText + ' *';
    }
  });

  // For multiple checkbox when one is already checked remove required on the rest of
  // the same family.
  elements
    .filter((el) => el.type === 'checkbox')
    .forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const checkboxUncheckedFamily = document.querySelectorAll(
          `input[name="${checkbox.name}"]:not(:checked)`
        );
        const checkboxCheckedFamily = document.querySelectorAll(
          `input[name="${checkbox.name}"]:checked`
        );

        if (checkboxCheckedFamily.length > 0) {
          checkboxUncheckedFamily.forEach((el) => (el.required = false));

          return;
        }

        checkboxUncheckedFamily.forEach(
          (unchecked) => (unchecked.required = elements[0].required)
        );
      });
    });
}

/**
 * Manage fielset display when farmer
 * @param {Element} form
 */
function manageFormVisibleElement(form) {
  const FIELDSETS_TO_DYNAMISE = {
    EXPLOITATION: 'infos-exploitation',
    OTHER: 'autres'
  };

  const FARMER = '1';

  const profile = form.querySelector('#profile');

  profile.addEventListener('change', ({ currentTarget }) => {
    const value = currentTarget.value;

    const other = document.getElementById(FIELDSETS_TO_DYNAMISE.OTHER);
    const exploitation = document.getElementById(
      FIELDSETS_TO_DYNAMISE.EXPLOITATION
    );

    if (value !== FARMER) {
      if (other && !other.classList.contains('hidden')) {
        other.classList.add('hidden');
      }

      if (exploitation && !exploitation.classList.contains('hidden')) {
        exploitation.classList.add('hidden');
      }

      return;
    }

    if (other) {
      other.classList.toggle('hidden');

      const inputs = other.querySelectorAll('input');
      const selects = other.querySelectorAll('select');

      toggleRequired([...inputs, ...selects]);
    }

    if (exploitation) {
      exploitation.classList.toggle('hidden');

      const inputs = exploitation.querySelectorAll('input');
      const selects = exploitation.querySelectorAll('select');

      toggleRequired([...inputs, ...selects]);
    }
  });
}

async function landingFormManagment() {
  const form = document.querySelector('.tb-blockLandingForm > form');

  if (!form) return;

  manageFormVisibleElement(form);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const formUrl = form.getAttribute('action');
    const formData = new FormData(form);
    const alert = document.querySelector('#form-alert');
    const successMessage = document.querySelector('#form-success-message');

    // mettre le loader dans le boutton
    form.classList.add('is-loading');

    const defaultMessage =
      'Une erreur est survenue lors de la soumission du formulaire';

    const toggleAlert = (message = defaultMessage) => {
      if (!alert) return;

      alert.classList.toggle('hidden');
      alert.innerHTML = message;

      alert.scrollIntoView(scroolToOptions);
    };

    try {
      const { status } = await axios({
        method: 'POST',
        url: formUrl,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        data: formData
      });

      form.classList.remove('is-loading');

      if (status !== 200) return;

      form.remove();

      document.getElementById('title-form').remove();
      successMessage.classList.toggle('hidden');
      successMessage.scrollIntoView(scroolToOptions);
    } catch (error) {
      toggleAlert(
        error.response.data.description
      );

      form.classList.remove('is-loading');
    }
  });
}

landingFormManagment();
limitCheckbox();
